const { gql } = require('@apollo/client');

export const QUERY_NOTIFICATIONS = gql`
  query Notifications {
    notifications {
      all {
        _id
        Title
        DescriptionHtml
        Date
        ShouldPopup
      }
    }
  }
`;

export const QUERY_UNSEEN_NOTIFICATIONS = gql`
  query Notifications {
    notifications {
      unseenNotifications {
        _id
        Title
        DescriptionHtml
        Date
        ShouldPopup
      }
    }
  }
`;

export const MUTATION_SEEN_NOTIFICATION = gql`
  mutation Notifications($id: String!) {
    notifications {
      seenNotification(id: $id)
    }
  }
`;

export const MUTATION_SEEN_ALL_NOTIFICATION = gql`
  mutation Notifications {
    notifications {
      seenAll
    }
  }
`;
